module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-9-sm-f6238b93894f1ec2657f970afb49e4b8.png";